module.exports = __webpack_public_path__ + "static/img/right.9848bf8c.png";